import { getSnowplowEventPayload, logAnalyticsEvent } from '../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../analytics.const';

const {
	MARKETPLACE: { SAVED_SEARCH_FILTER_ACTIVE, SAVED_SEARCH_LIST },
} = ANALYTICS_CATEGORIES;

export const triggerUserClickedShowVehiclesEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_show_vehicles_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSavedSearchItemHoverEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_hover_item',
		schemaName: SNOWPLOW_EVENTS.HOVER.SCHEMA,
		version: SNOWPLOW_EVENTS.HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSavedSearchPopoverCloseClickEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_popover_closed',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSavedSearchPopoverEditClickEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_popover_edit_button_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSavedSearchPopoverCreateClickEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_popover_create_button_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSavedSearchPopoverEditHoverEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_popover_edit_button_hovered',
		schemaName: SNOWPLOW_EVENTS.HOVER.SCHEMA,
		version: SNOWPLOW_EVENTS.HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSavedSearchPopoverShowVehiclesHoverEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_popover_show_vehicles_button_hovered',
		schemaName: SNOWPLOW_EVENTS.HOVER.SCHEMA,
		version: SNOWPLOW_EVENTS.HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerUserDisabledSavedSearchEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_FILTER_ACTIVE,
		name: 'dlr_saved_search_disabled',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerUserClickedEmptySavedSearchPillEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_empty_pill_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerUserHoveredActivePillEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_FILTER_ACTIVE,
		name: 'dlr_saved_search_active_pill_hovered',
		schemaName: SNOWPLOW_EVENTS.HOVER.SCHEMA,
		version: SNOWPLOW_EVENTS.HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerUserHoveredEmptyPillEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SAVED_SEARCH_LIST,
		name: 'dlr_saved_search_empty_pill_hovered',
		schemaName: SNOWPLOW_EVENTS.HOVER.SCHEMA,
		version: SNOWPLOW_EVENTS.HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
